import {
	Component,
	OnInit
} from '@angular/core';
import { Router } from '@angular/router';
import { MsalService } from '@azure/msal-angular';

/** This component handles redirecting users to the auth provider */
@Component({
    template: `
		<div style="text-align: center; margin-top: 50px;">
			<h3>Redirecting to Microsoft login...</h3>
		</div>
	`,
    standalone: false
})
export class LoginComponent implements OnInit {

	/** Creates a new instance of the LoginComponent */
	constructor(
		private readonly router: Router,
		private readonly msalService: MsalService
	) {
		// MSAL is the only authentication method
	}

	/** once the component is up and running, redirect the user to the auth provider */
	ngOnInit() {
		// Check if user is already logged in
		const accounts = this.msalService.instance.getAllAccounts();
		
		if (accounts.length > 0) {
			// User is already logged in, set active account and navigate to home
			this.msalService.instance.setActiveAccount(accounts[0]);
			this.router.navigate(['/home']);
		} else {
			// No account, initiate login
			this.msalService.loginRedirect();
		}
	}
}
